export default {
    url: 'load-shedding',
    include: ['za'],
};
